var _path, _path2, _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportHeader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    fill: "#D8D8D8",
    d: "M0 0h26v26H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.067 5.901a1.57 1.57 0 011.57-1.569h10.728a1.57 1.57 0 011.569 1.57V19.97a.73.73 0 01-1.232.53.73.73 0 00-1.003 0l-.365.345a1.26 1.26 0 01-1.733 0 1.262 1.262 0 00-1.734 0 1.26 1.26 0 01-1.733 0 1.262 1.262 0 00-1.733 0c-.487.46-1.247.46-1.734 0l-.365-.345a.73.73 0 00-1.003 0 .73.73 0 01-1.232-.53V5.9z",
    fill: "url(#report-header_svg__a)",
    stroke: "#000",
    strokeWidth: 0.898
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.666 7.8h3.819z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.666 7.8h3.819",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.666 10.4h8.548z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.666 10.4h8.548",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.666 13.001h8.548z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.666 13.001h8.548",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.666 15.6h7.391z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.666 15.6h7.391",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "report-header_svg__a",
    x1: 11.799,
    y1: -3.157,
    x2: -3.138,
    y2: 10.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500"
  })))));
}
export default SvgReportHeader;